var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M19,20H1a1,1,0,0,1-.89-1.45L2,14.76A4.974,4.974,0,0,1,6.469,12h7.062A4.974,4.974,0,0,1,18,14.76l1.89,3.79a.992.992,0,0,1-.04.973A1,1,0,0,1,19,20ZM6.469,14a2.984,2.984,0,0,0-2.681,1.66L2.618,18H17.383l-1.171-2.34A2.983,2.983,0,0,0,13.532,14ZM10,10a5,5,0,1,1,5-5A5.006,5.006,0,0,1,10,10Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,10,2Z",
    transform: "translate(2.003 2)",
    fill: "#ffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24User);
export default __webpack_public_path__ + "static/media/icon-24-user.22f1b0c2f7e7a9dfa1cf013ffe713c06.svg";
export { ForwardRef as ReactComponent };